import request from '@/utils/request'
import { APP_ID } from '@/enums'
import { useRuntimeConfig } from '#imports'

export function getDownloadLink(data: {
  appId: APP_ID
  /** index 是默认官网渠道，不用传 channelCode，/download 是落地页，值从 query 的渠道来 */
  channelCode?: string
}): Promise<{ version: string; url: string }> {
  return request({
    url: '/api/box/upgrade/download/v1/h5',
    method: 'post',
    data
  })
}

export function report(data) {
  const env = useRuntimeConfig()
  return request({
    url: env.public.analyticTarget + '/api/analyticApp/appApi/event/verifySignature/event/report',
    method: 'post',
    data
  })
}

export function getShortLink(data: { originLink: string }): Promise<string> {
  return request({
    url: '/api/box/upgrade/shortLink/create',
    method: 'post',
    data
  })
}
